import { PseudoPostType } from 'constants/post';
import {
  DEFAULT_FILE_SOURCES,
  FileSourceType,
} from 'app/components/fileSourceInput/hooks/useFileSource';

export function getSourcesForPseudoType(
  pseudoType: PseudoPostType,
): readonly FileSourceType[] {
  if (pseudoType === PseudoPostType.Document) {
    return ['upload'];
  }
  return DEFAULT_FILE_SOURCES;
}
